<template>
  <div>
    <headerSection></headerSection>
    <div class="x-main-content x-history-page"
         :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
      <div class="container">

        <!-- Page Header -->
        <div class="x-page-header">
          <div class="x-page-title-component">
            <div class="-inner-wrapper">
              <div class="-icon-wrapper">
                <i class="fas fa-history"></i>
              </div>
              <h1 class="-title">ประวัติธุรกรรม</h1>
            </div>
          </div>
          <p class="-description">ดูประวัติการฝาก-ถอน และกิจกรรมทั้งหมดของคุณ</p>
        </div>

        <!-- Transaction Table -->
        <div class="x-history-table-section">
          <div class="x-table-wrapper">
            <table class="x-premium-table">
              <thead>
                <tr>
                  <th>
                    <div class="-th-content">
                      <i class="far fa-calendar-alt"></i>
                      <span>วัน/เวลา</span>
                    </div>
                  </th>
                  <th>
                    <div class="-th-content">
                      <i class="fas fa-exchange-alt"></i>
                      <span>ประเภท</span>
                    </div>
                  </th>
                  <th>
                    <div class="-th-content">
                      <i class="fas fa-coins"></i>
                      <span>จำนวน</span>
                    </div>
                  </th>
                  <th>
                    <div class="-th-content">
                      <i class="fas fa-check-circle"></i>
                      <span>สถานะ</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in history" :key="index">
                  <td class="-date">
                    <span class="-date-value">{{ item.createdateShow }}</span>
                  </td>
                  <td>
                    <span class="x-type-badge" :class="getTypeClass(item.type)">
                      {{ item.type }}
                    </span>
                  </td>
                  <td class="-amount">
                    <span :class="getAmountClass(item.type)">
                      {{ numberWithCommas(item.qty) }}
                    </span>
                  </td>
                  <td>
                    <span class="x-status-badge" :class="getStatusClass(item.status)">
                      <i :class="getStatusIcon(item.status)"></i>
                      <span>{{ getStatusText(item.status) }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Empty State -->
          <div class="x-empty-state" v-if="!history.length">
            <i class="fas fa-inbox"></i>
            <p>ยังไม่มีประวัติธุรกรรม</p>
          </div>
        </div>

      </div>
    </div>
    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
import _ from 'lodash'
export default {
  name: 'Promotion',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  data () {
    return {
      history: []
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    numberWithCommas (x) {
      if (!x) x = 0
      return Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    getTypeClass (type) {
      if (type === 'ฝาก') return '-deposit'
      if (type === 'ถอน') return '-withdraw'
      return '-bonus'
    },
    getAmountClass (type) {
      if (type === 'ถอน') return '-negative'
      return '-positive'
    },
    getStatusClass (status) {
      if (status === 'ดำเนินการแล้ว') return '-completed'
      if (status === 'ยกเลิก') return '-cancelled'
      return '-pending'
    },
    getStatusIcon (status) {
      if (status === 'ดำเนินการแล้ว') return 'fas fa-check-circle'
      if (status === 'ยกเลิก') return 'fas fa-times-circle'
      return 'fas fa-clock'
    },
    getStatusText (status) {
      if (status === 'ดำเนินการแล้ว') return 'สำเร็จ'
      if (status === 'ยกเลิก') return 'ยกเลิก'
      return 'รอดำเนินการ'
    }
  },
  async mounted () {
    this.scrollToTop()
    this.$store.commit('user/SET_LOADING', true)
    const user = this.getUserId()
    const history = []
    let lastdate = ''
    await firebase.firestore().collection('history').where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(500).get().then((snapshot) => {
      snapshot.forEach((doc) => {
        if (doc.data().qty) {
          const data = doc.data()
          data.key = doc.id
          data.createdateShow = moment(data.createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm')
          lastdate = data.createdate
          history.push(data)
        }
      })
    })
    await firebase.firestore().collection('spin').where('userkey', '==', user.key).where('createdate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'วงล้อ',
          createdate: doc.data().createdate,
          createdateShow: moment(doc.data().createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().value,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
    await firebase.firestore().collection('roulet').where('userkey', '==', user.key).where('createdate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'รูเล็ต',
          createdate: doc.data().createdate,
          createdateShow: moment(doc.data().createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().value,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
    await firebase.firestore().collection('continuous_deposit_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'ฝากต่อเนื่อง',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
    await firebase.firestore().collection('partner_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'พันธมิตร',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
    await firebase.firestore().collection('cashback_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'คืนยอดเล่น',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })

    this.history = _.orderBy(history, ['createdate'], ['desc'])
    this.$store.commit('user/SET_LOADING', false)
  }
}
</script>
<style scoped>
.x-history-page {
  min-height: 100vh;
  padding: 25px 0 120px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

/* Page Header */
.x-page-header {
  text-align: center;
  padding: 20px 0;
}

.x-page-title-component .-inner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.x-page-title-component .-icon-wrapper {
  width: 50px;
  height: 50px;
  background: linear-gradient(180deg, #ffe867 10%, #fe8a02);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(254, 195, 63, 0.5);
}

.x-page-title-component .-icon-wrapper i {
  font-size: 22px;
  color: #1b1b41;
}

.x-page-title-component .-title {
  font-family: 'Kanit', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #ffc107;
  margin: 0;
  text-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
}

.-description {
  color: #a0a0a0;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  margin-top: 10px;
}

/* Table Section */
.x-history-table-section {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid #fec33f;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 20px;
  box-shadow: 0 0 30px rgba(254, 195, 63, 0.15);
}

.x-table-wrapper {
  overflow-x: auto;
  max-height: calc(100vh - 280px);
  overflow-y: auto;
}

.x-premium-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 480px;
}

.x-premium-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
}

.x-premium-table th {
  background: linear-gradient(180deg, #7a02fa, #5a01c0);
  padding: 0;
}

.x-premium-table th .-th-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 15px 10px;
}

.x-premium-table th .-th-content i {
  color: #ffc107;
  font-size: 14px;
}

.x-premium-table th .-th-content span {
  color: #fff;
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  font-weight: 600;
}

.x-premium-table td {
  padding: 12px 10px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  color: #fff;
  transition: all 0.2s ease;
}

.x-premium-table tbody tr:nth-child(odd) td {
  background: rgba(50, 60, 80, 0.4);
}

.x-premium-table tbody tr:nth-child(even) td {
  background: rgba(44, 52, 70, 0.4);
}

.x-premium-table tbody tr:hover td {
  background: rgba(254, 195, 63, 0.1);
}

/* Date Column */
.-date .-date-value {
  color: #a0a0a0;
  font-size: 12px;
}

/* Type Badge */
.x-type-badge {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.x-type-badge.-deposit {
  background: rgba(74, 222, 128, 0.2);
  color: #4ade80;
  border: 1px solid rgba(74, 222, 128, 0.3);
}

.x-type-badge.-withdraw {
  background: rgba(248, 113, 113, 0.2);
  color: #f87171;
  border: 1px solid rgba(248, 113, 113, 0.3);
}

.x-type-badge.-bonus {
  background: rgba(96, 165, 250, 0.2);
  color: #60a5fa;
  border: 1px solid rgba(96, 165, 250, 0.3);
}

/* Amount Column */
.-amount span {
  font-weight: 600;
  font-size: 14px;
}

.-amount .-positive {
  color: #4ade80;
}

.-amount .-negative {
  color: #f87171;
}

/* Status Badge */
.x-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
}

.x-status-badge.-completed {
  background: rgba(74, 222, 128, 0.2);
  color: #4ade80;
}

.x-status-badge.-completed i {
  color: #4ade80;
}

.x-status-badge.-cancelled {
  background: rgba(248, 113, 113, 0.2);
  color: #f87171;
}

.x-status-badge.-cancelled i {
  color: #f87171;
}

.x-status-badge.-pending {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
}

.x-status-badge.-pending i {
  color: #fbbf24;
}

/* Empty State */
.x-empty-state {
  text-align: center;
  padding: 60px 20px;
}

.x-empty-state i {
  font-size: 60px;
  color: rgba(254, 195, 63, 0.3);
  margin-bottom: 20px;
}

.x-empty-state p {
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  color: #a0a0a0;
  margin: 0;
}

/* Responsive */
@media (max-width: 576px) {
  .x-premium-table th .-th-content {
    padding: 12px 5px;
    flex-direction: column;
    gap: 3px;
  }

  .x-premium-table th .-th-content span {
    font-size: 11px;
  }

  .x-premium-table td {
    padding: 10px 5px;
    font-size: 11px;
  }

  .x-type-badge {
    padding: 4px 8px;
    font-size: 10px;
  }

  .x-status-badge {
    padding: 4px 6px;
    font-size: 10px;
  }

  .x-status-badge span {
    display: none;
  }

  .-amount span {
    font-size: 12px;
  }

  .x-page-title-component .-title {
    font-size: 20px;
  }
}
</style>
